/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Workout_After_Carry_AddInputs */

const en_us2_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add to ${i?.day}`)
};

const pt_br2_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ao ${i?.day}`)
};

const es_419_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar a ${i?.day}`)
};

const pt_pt2_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ao ${i?.day}`)
};

const fr_fr2_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter à ${i?.day}`)
};

const de_de2_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu ${i?.day} hinzufügen`)
};

const it_it2_workout_after_carry_add = /** @type {(inputs: Workout_After_Carry_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi a ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Add to {day}" |
*
* @param {Workout_After_Carry_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_add = /** @type {((inputs: Workout_After_Carry_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_add(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_add(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_add(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_add(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_add(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_add(inputs)
	return en_us2_workout_after_carry_add(inputs)
});
export { workout_after_carry_add as "workout-after.carry_add" }